class t {
  constructor() {
    this.plane = null, this.referenceGeometry = null, this.status = 0, this.updateReferenceGeometry = !1;
  }
}
export {
  t as CuttingPlaneInfo
};
//# sourceMappingURL=CuttingPlaneInfo.mjs.map
